export default "__VITE_ASSET__n4xk5hfA__"